import {
  BaseRequiredDialogProps,
  CanopyProvider,
  DialogDraggable,
} from '@bloomfieldrobotics/canopy';
import { DialogContent } from '@mui/material';
import { useTranslation } from '../../../services/translation/hooks/useTranslation';
import DebugInfo, { DebugInfoProps } from '../DebugInfo';
type Props = BaseRequiredDialogProps & DebugInfoProps;

const DebugInfoDialogOnboarding = ({
  open: isOpen,
  onClose,
  customerID,
  ranchID,
  blockID,
  scanID,
  pointID,
  debugInfoUserID,
}: Props) => {
  const { t } = useTranslation();

  return (
    <DialogDraggable
      title={t('Debug Info Onboarding')}
      open={isOpen}
      onClose={onClose}
    >
      <CanopyProvider>
        <DialogContent>
          <DebugInfo
            customerID={customerID}
            ranchID={ranchID}
            blockID={blockID}
            scanID={scanID}
            pointID={pointID}
            debugInfoUserID={debugInfoUserID}
          />
        </DialogContent>
      </CanopyProvider>
    </DialogDraggable>
  );
};

export default DebugInfoDialogOnboarding;
